import Aos from "aos";
import { useEffect } from "react";

const BankvoleTrustBadges = () => {
  useEffect(() => {
        Aos.init({
            duration: 1000,
        });
    }, []);
  return (
    <section className="bv-trust-bar">
      <div className="bv-trust-inner" data-aos="zoom-in" data-aos-duration="1200">
        <div className="bv-trust-item">
          <img
            src={`${process.env.PUBLIC_URL}/assets/img/central-bank-logo.svg`}
            alt="Central Bank of Nigeria"
            className="bv-trust-icon"
          />
          <p>Bankvole is licensed by the central bank of Nigeria</p>
        </div>

        <div className="bv-trust-item">
          <img
            src={`${process.env.PUBLIC_URL}/assets/img/ndpr.png`}
            alt="NDPR"
            className="bv-trust-icon"
          />
          <p>We are NDPR compliant</p>
        </div>

        <div className="bv-trust-item bv-trust-item--stat">
          <div className="bv-trust-avatars">
            <img src={`${process.env.PUBLIC_URL}/assets/img/avatar-1.jpg`} alt="" />
            <img src={`${process.env.PUBLIC_URL}/assets/img/avatar-2.jpg`} alt="" />
            <img src={`${process.env.PUBLIC_URL}/assets/img/avatar-3.png`} alt="" />
          </div>
          <div>
            <p className="bv-trust-stat-number">12,000+</p>
            <p className="bv-trust-stat-label">Downloads</p>
          </div>
        </div>

        <div className="bv-trust-item bv-trust-item--stat">
          <div>
            <p className="bv-trust-stat-number">4.8/5</p>
            <p className="bv-trust-stat-label">⭐⭐⭐⭐⭐ Rating</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BankvoleTrustBadges;